import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-12 h-12 mx-auto mb-4 rounded-full bg-primary-300 flex justify-center items-center flex-shrink-0" }
const _hoisted_2 = { class: "text-gray-500 text-sm leading-5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "mt-6"
}

import {
  DialogTitle,
} from '@headlessui/vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import ComponentLoader from '@/components/loaders/ComponentLoader.vue';
import { CheckIcon } from '@heroicons/vue/24/outline';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    cancelText: {
        type: String,
    },
    customClass: {
        type: String,
        default: 'w-[350px] min-w-[350px] pt-6 pb-12 px-10'
    },
    checkIcon: {
        type: Boolean,
        default: false
    },
    noBtn : {
        type: Boolean,
        default: false
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: __props.customClass,
    show: __props.show,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ComponentLoader, { customClass: "w-4 h-4" })
      ]),
      _createVNode(_unref(DialogTitle), {
        as: "p",
        class: "text-xl font-bold text-neutral-900",
        tabindex: "0"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        (__props.content)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.content), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "content")
      ]),
      (!__props.noBtn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(ButtonComponent, {
              size: "large",
              btnWidth: "primary rounded-lg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.actionText), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["customClass", "show"]))
}
}

})